import { ModeType } from 'theme/Theme.types';

export const getAppMode = (): ModeType => {
  return 'INDIVIDUAL';
};
